import React, { useEffect, useState } from 'react';
import Icon from './Icon';
import { buildRefundPolicyBulletItems, fetchRefundPolicy } from '../../utils/refundPolicy';

const RefundPolicyNotice = ({ compact = false, policy: policyProp = null }) => {
  const [policy, setPolicy] = useState(policyProp);

  useEffect(() => {
    if (policyProp) {
      setPolicy(policyProp);
      return;
    }
    fetchRefundPolicy().then(setPolicy);
  }, [policyProp]);

  const items = buildRefundPolicyBulletItems(policy);

  return (
    <div
      style={{
        borderRadius: '10px',
        padding: compact ? '12px 14px' : '16px',
        background: '#fffbeb',
        border: '1px solid #fde68a',
        color: '#92400e',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
        <Icon name="warn" size={compact ? 16 : 18} color="#b45309" />
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 700, fontSize: compact ? '13px' : '14px', marginBottom: compact ? '6px' : '8px' }}>
            Refund form deadline & penalty
          </div>
          <ul
            style={{
              margin: 0,
              paddingLeft: '18px',
              fontSize: compact ? '12px' : '13px',
              lineHeight: 1.6,
            }}
          >
            {items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyNotice;
